import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Components, Theme, Utils, translate,
} from 'versafleet-core';
import Page from 'pages/page';
import ReduxActions from 'reduxActions';
import moment from 'moment';

const {
  FullScreenLoading, Helper, DateHelper, TranslationHelper, Router,
} = Utils;
const { Color } = Theme;

class NotificationPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: this._getDefaultFilter(),
    };
  }

  UNSAFE_componentWillMount() {
    this._loadList();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.filter !== this.state.filter) {
      this._loadList();
    }
  }

  _getDefaultFilter = () => ({
    date: DateHelper.today(),
    page: 1,
    per_page: 20,
  });

  _onFilterChange = (fieldName, value) => {
    this.setState(prevState => ({
      filter: Helper.setFilter(prevState.filter, fieldName, value),
    }));
  }

  _loadList() {
    FullScreenLoading.FullScreenLoadingManager.open(this.props.strings.loadingItems);
    this.props.dispatch(ReduxActions.notification.fetchList(this.state.filter))
      .then(() => FullScreenLoading.FullScreenLoadingManager.close());
  }

  _loadNotificationItem = (notification) => {
    if (notification.category.includes('job')) {
      const id = notification.data.job.id;
      if (notification.category.includes('accepted')) {
        Router.transitionTo(`in_progress/jobs/${id}`);
      } else {
        Router.transitionTo(`submissions/jobs/${id}`);
      }
    } else {
      const id = notification.data.task.id;
      Router.transitionTo(`in_progress/tasks/${id}`);
    }
  }

  _renderActionPanel() {
    const { meta } = this.props;

    return (
      <Components.ActionPanel>
        <Components.Paginator
          currentPage={meta.page}
          id="vf-notifications-page__paginator"
          isCountCustomizable
          itemsPerPage={meta.per_page}
          model="Notifications"
          onChange={this._onFilterChange}
          totalItems={meta.total}
        />
        <Components.Input.DatePicker
          id="vf-notifications-page__datepicker"
          onChange={value => this._onFilterChange('date', value)}
          placeholder="Pick a date"
          value={this.state.filter.date}
        />
      </Components.ActionPanel>
    );
  }

  _renderJob(notification, keyword) {
    const replaceMap = {
      customerName: (
        <span className="notification_panel--item--blue">
          {`${notification.data.job.customer.name} `}
        </span>
      ),
      keyword: (
        <span className="notification_panel--item--bold">
          {this.props.strings.constants[keyword]}
        </span>
      ),
      guid: (
        <span className="notification_panel--item--blue">
          {` ${notification.data.job.guid} `}
        </span>
      ),
    };

    return (
      <Components.LineItem
        id="vf-notifications-page__job-item"
        onClick={() => this._loadNotificationItem(notification)}
      >
        <Components.LineItem.IconBlock iconClassName="versa-business" iconText="" />

        <Components.LineItem.Block size="EXTRA_LARGE">
          <Components.LineItem.BlockContent fontSize="LARGE">
            <div>
              {TranslationHelper.replaceTag(this.props.strings.job, replaceMap)}
            </div>
          </Components.LineItem.BlockContent>
        </Components.LineItem.Block>

        <Components.LineItem.ButtonGroup isPersistent>
          <div className="notification--overview--created_time">
            {moment(notification.created_at).fromNow(true)}
          </div>
        </Components.LineItem.ButtonGroup>

      </Components.LineItem>
    );
  }

  _renderCompletedJob(notification) {
    const replaceMap = {
      guid: (
        <span className="notification_panel--item--blue">
          {notification.data.job.guid}
        </span>
      ),
      customerName: (
        <span className="notification_panel--item--blue">
          {notification.data.job.customer.name}
        </span>
      ),
    };

    return (
      <Components.LineItem
        id="vf-notifications-page__job-item"
        onClick={() => this._loadNotificationItem(notification)}
      >

        <Components.LineItem.IconBlock iconClassName="versa-business" iconText="" />

        <Components.LineItem.Block size="EXTRA_LARGE">
          <Components.LineItem.BlockContent fontSize="LARGE">
            <div>
              {TranslationHelper.replaceTag(this.props.strings.completedJob, replaceMap)}
            </div>
          </Components.LineItem.BlockContent>
        </Components.LineItem.Block>

        <Components.LineItem.ButtonGroup isPersistent>
          <div className="notification--overview--created_time">
            {moment(notification.created_at).fromNow(true)}
          </div>
        </Components.LineItem.ButtonGroup>

      </Components.LineItem>
    );
  }

  _renderAcceptedJob(notification) {
    const replaceMap = {
      guid: (
        <span className="notification_panel--item--blue">
          {notification.data.job.guid}
        </span>
      ),
    };

    return (
      <Components.LineItem
        id="vf-notifications-page__job-item"
        onClick={() => this._loadNotificationItem(notification)}
      >

        <Components.LineItem.IconBlock iconClassName="versa-business" iconText="" />

        <Components.LineItem.Block size="EXTRA_LARGE">
          <Components.LineItem.BlockContent fontSize="LARGE">
            <div>
              {TranslationHelper.replaceTag(this.props.strings.acceptedJob, replaceMap)}
            </div>
          </Components.LineItem.BlockContent>
        </Components.LineItem.Block>

        <Components.LineItem.ButtonGroup isPersistent>
          <div className="notification--overview--created_time">
            {moment(notification.created_at).fromNow(true)}
          </div>
        </Components.LineItem.ButtonGroup>

      </Components.LineItem>
    );
  }

  _renderRejectedJob(notification) {
    const replaceMap = {
      guid: (
        <span className="notification_panel--item--blue">
          {notification.data.job.guid}
        </span>
      ),
      reason: (
        <span className="vf-header-notification__item__description--bold">
          {notification.data.myjobs_rejection_note}
        </span>
      ),
    };

    return (
      <Components.LineItem
        id="vf-notifications-page__job-item"
        onClick={() => this._loadNotificationItem(notification)}
      >

        <Components.LineItem.IconBlock iconClassName="versa-business" iconText="" />

        <Components.LineItem.Block size="EXTRA_LARGE">
          <Components.LineItem.BlockContent fontSize="LARGE">
            {
              !Helper.isNonEmptyString(notification.data.myjobs_rejection_note) ? (
                <div>
                  {TranslationHelper.replaceTag(this.props.strings.rejectedJobWithoutReason,
                    replaceMap)}
                </div>
              ) : (
                <div>
                  {TranslationHelper.replaceTag(this.props.strings.rejectedJob, replaceMap)}
                </div>
              )
            }
          </Components.LineItem.BlockContent>
        </Components.LineItem.Block>

        <Components.LineItem.ButtonGroup isPersistent>
          <div className="notification--overview--created_time">
            {moment(notification.created_at).fromNow(true)}
          </div>
        </Components.LineItem.ButtonGroup>

      </Components.LineItem>
    );
  }

  _renderTask(notification, keyword) {
    const iconClassNamesMap = {
      acknowledged: 'versa-arrow-down',
      started: 'versa-started2',
      declined: 'versa-warning',
      failed: 'versa-warning',
      cancelled: 'versa-danger',
      succeeded: 'versa-completed',
      collected: 'versa-completed',
      arrived: 'versa-arrived',
    };

    const innerIconColorMap = {
      acknowledged: Color.$desc,
      started: Color.$desc,
      declined: Color.$bluelighter1,
      failed: Color.$bluelighter1,
      cancelled: Color.$bluelighter1,
      succeeded: Color.$white,
      collected: Color.$green,
      arrived: Color.$white,
    };

    const outerIconColorMap = {
      acknowledged: Color.$teal01,
      started: Color.$teal01,
      declined: Color.$red,
      failed: Color.$red,
      cancelled: Color.$red,
      succeeded: Color.$green,
      collected: Color.$green,
      arrived: Color.$green,
    };

    const shouldShowPartial = notification.data.task.is_partial_success && keyword === 'succeeded';

    const replaceMap = {
      partial: shouldShowPartial ? (
        <span className="notification_panel--item--bold">
          {this.props.strings.partial}
        </span>
      ) : false,
      driverName: (
        <span className="notification_panel--item--blue">
          {Helper.isNullOrUndefined(notification.data.task.task_assignment.driver) ? ''
            : notification.data.task.task_assignment.driver.name}
        </span>
      ),
      keyword: (
        <span className="notification_panel--item--bold">
          {this.props.strings.driverConstants[keyword]}
        </span>
      ),
      guid: (
        <span className="notification_panel--item--blue">
          {notification.data.task.guid}
        </span>
      ),
      customerName: (
        <span className="notification_panel--item--blue">
          {notification.data.task?.job?.customer?.name || notification.data.task?.customer?.name}
        </span>
      ),
    };

    return (
      <Components.LineItem
        id="vf-notifications-page__task-item"
        onClick={() => this._loadNotificationItem(notification)}
        showCheckBox={false}
      >
        <Components.LineItem.IconBlock
          className={`notification_panel--item--${keyword}`}
          iconClassName={shouldShowPartial ? 'versa-completedpartially' : iconClassNamesMap[keyword]}
          innerIconColor={innerIconColorMap[keyword]}
          outerIconColor={outerIconColorMap[keyword]}
        />

        <Components.LineItem.Block size="EXTRA_LARGE">
          <Components.LineItem.BlockContent fontSize="LARGE">
            {Helper.isNullOrUndefined(notification.data.task.task_assignment.driver) ? (
              <div>
                {TranslationHelper.replaceTag(this.props.strings.taskWithoutDriver,
                  replaceMap)}
              </div>
            ) : (
              <div>
                {TranslationHelper.replaceTag(this.props.strings.taskWithDriver,
                  replaceMap)}
              </div>
            )}
          </Components.LineItem.BlockContent>
        </Components.LineItem.Block>

        <Components.LineItem.ButtonGroup isPersistent>
          <div className="notification--overview--created_time">
            {moment(notification.created_at).fromNow(true)}
          </div>
        </Components.LineItem.ButtonGroup>

      </Components.LineItem>
    );
  }

  _renderNotificator(notification) {
    const { notificator, task } = notification.data;
    const { strings } = this.props;

    const absoluteMinutes = Math.abs(notificator.minutes);

    const replaceMap = {
      taskGUID: (
        <span className="notification_panel--item--blue">
          {task.guid}
        </span>
      ),
      hasBeen: (
        <span className="notification_panel--item--bold">
          {notificator.is_been ? strings.isBeen : strings.isNotBeen}
        </span>
      ),
      actionName: (
        <span className="notification_panel--item--bold">
          {strings.notificatorConstants[notificator.action_name]}
        </span>
      ),
      hourCount: (
        <span className="notification_panel--item--bold">
          {Math.floor(absoluteMinutes / 60)}
        </span>
      ),
      hours: (
        <span className="notification_panel--item--bold">
          {strings.hours}
        </span>
      ),
      minuteCount: (
        <span className="notification_panel--item--bold">
          {absoluteMinutes % 60}
        </span>
      ),
      minutes: (
        <span className="notification_panel--item--bold">
          {strings.minutes}
        </span>
      ),
      timePreposition: (
        <span className="notification_panel--item--bold">
          {parseInt(notificator.minutes, 10) < 0 ? strings.after : strings.before}
        </span>
      ),
      time: (
        <span>
          {moment(task[notificator.trigger_name]).format('HH:mm:ss, DD MMM YYYY')}
        </span>
      ),
    };

    return (
      <Components.LineItem
        id="vf-notifications-page__notificator-item"
        onClick={() => this._loadNotificationItem(notification)}
        showCheckBox={false}
      >
        <Components.LineItem.IconBlock
          iconClassName="versa-notifications"
          iconText=""
        />

        <Components.LineItem.Block size="EXTRA_LARGE">
          <Components.LineItem.BlockContent fontSize="LARGE">
            <div>
              {notificator.minutes >= 60
                ? TranslationHelper.replaceTag(strings.notificatorWithHours, replaceMap)
                : TranslationHelper.replaceTag(strings.notificatorWithoutHours, replaceMap)}
            </div>
          </Components.LineItem.BlockContent>
        </Components.LineItem.Block>

        <Components.LineItem.ButtonGroup isPersistent>
          <div className="notification--overview--created_time">
            {moment(notification.created_at).fromNow(true)}
          </div>
        </Components.LineItem.ButtonGroup>

      </Components.LineItem>
    );
  }

  _renderItem(notification) {
    switch (notification.category) {
      case 'job_completed':
        return this._renderCompletedJob(notification);
      case 'job_rejected':
        return this._renderRejectedJob(notification);
      case 'job_accepted':
        return this._renderAcceptedJob(notification);
      case 'job_submitted':
        return this._renderJob(notification, 'submitted');
      case 'job_revoked':
        return this._renderJob(notification, 'retracted');
      case 'job_cancelled':
        return this._renderJob(notification, 'cancelled');
      case 'task_acknowledged':
        return this._renderTask(notification, 'acknowledged');
      case 'task_declined':
        return this._renderTask(notification, 'declined');
      case 'task_started':
        return this._renderTask(notification, 'started');
      case 'task_failed':
        return this._renderTask(notification, 'failed');
      case 'task_rejected':
        return this._renderTask(notification, 'rejected');
      case 'task_successful':
        return this._renderTask(notification, 'succeeded');
      case 'task_collected':
        return this._renderTask(notification, 'collected');
      case 'task_arrived':
        return this._renderTask(notification, 'arrived');
      case 'task_cancelled':
        return this._renderTask(notification, 'cancelled');
      case 'task_notificator':
        return this._renderNotificator(notification);
      default:
        return null;
    }
  }

  _renderPageContent() {
    return this.props.notifications.map(notification => this._renderItem(notification));
  }

  render() {
    return (
      <Page {...this.props}>
        {this._renderActionPanel()}
        {this._renderPageContent()}
      </Page>
    );
  }
}

NotificationPage.displayName = 'Notification Page';

NotificationPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  meta: PropTypes.shape({
    page: PropTypes.number,
    per_page: PropTypes.number,
    total: PropTypes.number,
  }).isRequired,
  notifications: PropTypes.arrayOf(PropTypes.shape({
    category: PropTypes.string,
    data: PropTypes.shape(),
  })).isRequired,
  strings: PropTypes.shape().isRequired,
};

function mapStateToProps(state) {
  const { notification } = state;
  return {
    notifications: notification.notifications,
    meta: notification.notificationMeta,
  };
}

export default connect(mapStateToProps)(translate('Notification')(NotificationPage));
